import { Control, ControlType } from './control';

export class TextControl extends Control<string> {
  constructor(name: string, placeholder: string) {
    super(name, placeholder, ControlType.text, '');
  }

  isValid(): boolean {
    return this.required ? this.value !== '' : true;
  }
}
